import './footer.scss'
import type { FC } from 'react'
import { NewsletterSignUp } from '@/common/components/newsletterSignUp/NewsletterSignUp'
import { Banner } from './subcomponents/Banner'
import { FeatureLinks } from './subcomponents/FeatureLinks'
import { LowerFooter } from './subcomponents/LowerFooter'
import { SecondaryLinks } from './subcomponents/SecondaryLinks'
import { SocialAndAppLinks } from './subcomponents/SocialAndAppLinks'

export const Footer: FC = () => {
    return (
        <footer>
            <Banner />
            <div className="footer-content container-lg-padding">
                <FeatureLinks />
                <SecondaryLinks />
                <SocialAndAppLinks />
                <NewsletterSignUp className={'footer-newsletter'} />
            </div>
            <LowerFooter />
        </footer>
    )
}
